<!--

	Contains information about core or elective subject that website offers.
	Also, contains styles for pdf version.

-->
<template>
	<div class="mia-ScopeAndSequenceContent" :class="{
		'mia-pdf': pdf,
	}"
	>
		<div class="mia-titlePage">
			<h5 v-tr="'scopeandsequence_title'" class="mia-title" />
			<h2 v-tr="subjectTrKey" class="mia-subject" />
		</div>
		<div class="mia-information">
			<h4 v-tr="isCoreSubject ? 'scopeandsequence_core_subjects_headline' : 'scopeandsequence_elective_subjects_headline'" class="mia-header" />
			<div v-tr="isCoreSubject ? 'scopeandsequence_core_subjects_explanation' : 'scopeandsequence_elective_subjects_explanation'" class="mia-explanation" />
		</div>
		<div class="mia-lineSeparator" />
		<scope-and-sequence-course
			v-for="course in config.Courses"
			:key="course.Name" 
			:course="course"
		/>
		<div class="mia-lineSeparator" />
		<div class="mia-information mia-pageBreak--before">
			<h4 v-tr="'scopeandsequence_appliedlearning_headline'" />
			<div v-tr="'scopeandsequence_appliedlearning_explanation'" class="mia-explanation" />
		</div>
		<div class="mia-lineSeparator" />
		<div class="mia-information">
			<h4 v-tr="'scopeandsequence_writing_newspaper_headline'" />
			<div v-tr="'scopeandsequence_writing_newspaper_explanation'" class="mia-explanation" />
		</div>
		<div class="mia-lineSeparator" />
		<div class="mia-information">
			<h4 v-tr="'scopeandsequence_creatingartwork_headline'" />
			<div v-tr="'scopeandsequence_creatingartwork_explanation'" class="mia-explanation" />
		</div>
		<div class="mia-lineSeparator" />
		<div class="mia-pageBreak--before">
			<div class="mia-information">
				<h4 v-tr="'scopeandsequence_business_simulation_headline'" />
				<div v-tr="'scopeandsequence_business_simulation_explanation'" class="mia-explanation" />
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { MiaPlaza } from "@/Reinforced.Typings";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import ScopeAndSequenceCourse from "./ScopeAndSequenceCourse.vue";
import ResponsiveButton from "../../../../Control/Vue/ResponsiveButton.vue";
import SubjectHelper from "@/utils/SubjectHelper";

@Component({
	components: {
		ScopeAndSequenceCourse,
		ResponsiveButton,
	},
})
export class ScopeAndSequence extends Vue {
	@Prop({required: true, type: Object}) config!: MiaPlaza.LO.Curriculum.ScopeAndSequence.IScopeAndSequenceData;
	@Prop({required: true, type: Boolean}) pdf!: boolean;

	get isCoreSubject(): boolean {
		return SubjectHelper.GetCoreSubjects().includes(this.config.Subject);
	}

	get subjectTrKey() {
		return SubjectHelper.GetTrKey(this.config.Subject);
	}
}

export default toNative(ScopeAndSequence);
</script>
<style lang="scss">
.mia-ScopeAndSequenceContent {
	padding: theme.$mia-padding-panel;
	padding-top: 0px;
	.mia-titlePage {
		display: flex;
		align-items: flex-start;
		position: relative;
		flex-direction: column;
		width: 100%;
		justify-content: center;

		.mia-subject {
			background-color: inherit;
			color: theme.$mia-color-highContrastContainer;
			margin-top: 0px;
		}

		.mia-title {
			background-color: inherit;
			color: theme.$mia-color-ListHeaderFooter-font;
			text-transform: uppercase;
		}
	}

	.mia-header {
		background-color: inherit;
		color: theme.$mia-color-highContrastContainer;
	}

	.mia-explanation,
	.mia-information {
		text-align: left;
	}

	.mia-explanation {
		white-space: pre-line;
	}

	.mia-lineSeparator {
		margin-bottom: theme.$mia-padding-panel-huge;
		margin-top: theme.$mia-padding-panel-large;
		background-color: theme.$mia-color-panel-separator;
		height: theme.$mia-border-width-panel-small;
	}

	// Styles for pdf version
	&.mia-pdf {
		// override title page height so it matches the pdf format
		.mia-titlePage {
			margin-top: theme.$mia-margin-size-huge;
		}

		// exclude padding for the last lesson because padding may lead to empty pages in pdf version
		.mia-lesson:last-child {
			padding-bottom: 0;
		}

		// override line height for pdf version, because characters are being cut off
		// when we move to a new font-family probably we will not need this anymore
		.mia-lessonName {
			line-height: 1.5;
		}

		.mia-lineSeparator {
			display: none;
		}

		.mia-pageBreak--before {
			padding-top: theme.$mia-padding-panel;
		}

		.glyphicon {
			top: calc(theme.$mia-padding-panel-small / 2);
		}
	}

	@media(max-width: theme.$screen-sm-max) {
		.mia-titlePage {
			margin-top: theme.$mia-margin-size;
		}
	}
}
</style>
